import React from 'react';
import Icon from './Icon';

const FilterIcon = (props) => (
    <Icon {...props}>
        <path
            d="M3 4.5H21L14 12.5V18.5L10 20.5V12.5L3 4.5Z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default FilterIcon;